export enum SaleType {
	ClaimMintPasses = 'Claim Mint Passes',
	RedeemMintPasses = 'Redeem Mint Passes',
	ClaimWhitelistGoats = 'Claim Whitelist Goats',
	MintGoats = 'Mint Goats',
}

export interface SaleSchedule {
	isActive: boolean
	tokenPriceInEth?: number
	maxTxnAmount: number
	totalSupply: number
	description: string
}

export const SalesInfo: { [type: string]: SaleSchedule } = {
	[SaleType.ClaimMintPasses]: {
		isActive: true,
		tokenPriceInEth: 0.025,
		maxTxnAmount: 2,
		totalSupply: 500,
		description: 'Claim a Gnarly Goat Mint Pass',
	},
	[SaleType.RedeemMintPasses]: {
		isActive: true,
		maxTxnAmount: 2,
		totalSupply: 500,
		description: 'Redeem your mint passes for Gnarly Goats',
	},
	[SaleType.ClaimWhitelistGoats]: {
		isActive: false,
		tokenPriceInEth: 0.1,
		maxTxnAmount: 2,
		totalSupply: 1200,
		description: 'Claim a Whitelist Goat',
	},
	[SaleType.MintGoats]: {
		isActive: true,
		tokenPriceInEth: 0.1,
		maxTxnAmount: 20,
		totalSupply: 5366,
		description: 'Mint some Gnarly Goats',
	},
}
